/**
 * @module geo/payload/facade
 */
import {MapOptions} from '../../types/map';
import {AddMenuItemOptions, MenuItem} from '../../types/menu.item';

/**
 * Action to add menu item to functions launcher component
 * @since v 2.1.0
 */
export class ADD_MENU_ITEM {
  public map?: MapOptions|null;

  /**
   * new menu item description
   */
  public menuItem: MenuItem;

  /**
   * add menu item options
   */
  public options?: AddMenuItemOptions;

  /**
   * @param options object with properties values
   */
  constructor(options: any) {
    Object.assign(this, options);
    this.menuItem = options.menuItem;
  }
}